module.exports = __webpack_public_path__ + "img/logo_for_contract.c9b46acb.png";